import { Text, View } from '@react-pdf/renderer';

import type { Scan } from '../../../../api/generated/insights.schemas';
import { palette, styles } from '../styles';

interface CompetitorRankingSectionProps {
  scan: Scan;
}

export default function CompetitorRankingSection({
  scan,
}: CompetitorRankingSectionProps) {
  const list = scan.rankings?.list ?? [];
  const totalQueries = scan.numberOfQueries;

  if (list.length === 0) {
    return (
      <View>
        <Text style={styles.sectionTitle}>Competitor ranking</Text>
        <Text style={styles.sectionSubtitle}>
          The selected AI platform returned no brands for the queries.
        </Text>
      </View>
    );
  }

  return (
    <View>
      <Text style={styles.sectionTitle}>Competitor ranking</Text>
      <Text style={styles.sectionSubtitle}>
        Brands with the most mentions for the submitted queries.
      </Text>

      <View style={styles.table}>
        <View style={styles.tableHeader} fixed>
          <Text style={[styles.tableHeaderCell, { width: 50 }]}>Rank</Text>
          <Text style={[styles.tableHeaderCell, { flex: 1 }]}>Brand</Text>
          <Text
            style={[
              styles.tableHeaderCell,
              { width: 90, textAlign: 'right' },
            ]}
          >
            Mentions
          </Text>
        </View>

        {list.map((row, idx) => {
          const isLast = idx === list.length - 1;
          const isSelf = !!row.brand?.isSelf;
          return (
            <View
              key={row.id ?? `${idx}`}
              style={[styles.tableRow, isLast ? styles.tableRowLast : {}]}
              wrap={false}
            >
              <Text style={[styles.tableCell, { width: 50 }]}>
                #{row.rank?.value ?? '—'}
              </Text>
              <Text
                style={[
                  styles.tableCell,
                  {
                    flex: 1,
                    color: isSelf ? palette.primary : palette.text,
                    fontFamily: isSelf ? 'Helvetica-Bold' : 'Helvetica',
                  },
                ]}
              >
                {row.brand?.name ?? '—'}
                {isSelf ? ' (you)' : ''}
              </Text>
              <Text
                style={[styles.tableCell, { width: 90, textAlign: 'right' }]}
              >
                {row.brand?.numberOfMentions?.value ?? 0}
                {typeof totalQueries === 'number' ? (
                  <Text style={{ color: palette.muted }}>
                    {` / ${totalQueries}`}
                  </Text>
                ) : null}
              </Text>
            </View>
          );
        })}
      </View>
    </View>
  );
}
